export type WhatsappCountry = {
    iso2: string;   // unik (ISO 3166-1 alpha-2)
    code: string;   // calling code (kan gentage sig, fx +1, +7, +44)
    country: string;
};

export const WHATSAPP_COUNTRIES: WhatsappCountry[] = [
    { iso2: "AF", code: "+93", country: "Afghanistan" },
    { iso2: "AL", code: "+355", country: "Albania" },
    { iso2: "DZ", code: "+213", country: "Algeria" },
    { iso2: "AD", code: "+376", country: "Andorra" },
    { iso2: "AO", code: "+244", country: "Angola" },
    { iso2: "AG", code: "+1", country: "Antigua and Barbuda" },
    { iso2: "AR", code: "+54", country: "Argentina" },
    { iso2: "AM", code: "+374", country: "Armenia" },
    { iso2: "AU", code: "+61", country: "Australia" },
    { iso2: "AT", code: "+43", country: "Austria" },
    { iso2: "AZ", code: "+994", country: "Azerbaijan" },
    { iso2: "AW", code: "+297", country: "Aruba" },

    { iso2: "BS", code: "+1", country: "Bahamas" },
    { iso2: "BH", code: "+973", country: "Bahrain" },
    { iso2: "BD", code: "+880", country: "Bangladesh" },
    { iso2: "BB", code: "+1", country: "Barbados" },
    { iso2: "BY", code: "+375", country: "Belarus" },
    { iso2: "BE", code: "+32", country: "Belgium" },
    { iso2: "BZ", code: "+501", country: "Belize" },
    { iso2: "BJ", code: "+229", country: "Benin" },
    { iso2: "BT", code: "+975", country: "Bhutan" },
    { iso2: "BO", code: "+591", country: "Bolivia" },
    { iso2: "BA", code: "+387", country: "Bosnia and Herzegovina" },
    { iso2: "BW", code: "+267", country: "Botswana" },
    { iso2: "BR", code: "+55", country: "Brazil" },
    { iso2: "BN", code: "+673", country: "Brunei" },
    { iso2: "BG", code: "+359", country: "Bulgaria" },
    { iso2: "BF", code: "+226", country: "Burkina Faso" },
    { iso2: "BI", code: "+257", country: "Burundi" },

    { iso2: "KH", code: "+855", country: "Cambodia" },
    { iso2: "CM", code: "+237", country: "Cameroon" },
    { iso2: "CA", code: "+1", country: "Canada" },
    { iso2: "CV", code: "+238", country: "Cape Verde" },
    { iso2: "CF", code: "+236", country: "Central African Republic" },
    { iso2: "TD", code: "+235", country: "Chad" },
    { iso2: "CL", code: "+56", country: "Chile" },
    { iso2: "CN", code: "+86", country: "China" },
    { iso2: "CO", code: "+57", country: "Colombia" },
    { iso2: "KM", code: "+269", country: "Comoros" },
    { iso2: "CG", code: "+242", country: "Congo" },
    { iso2: "CD", code: "+243", country: "Congo (DRC)" },
    { iso2: "CR", code: "+506", country: "Costa Rica" },
    { iso2: "CI", code: "+225", country: "Côte d’Ivoire" },
    { iso2: "HR", code: "+385", country: "Croatia" },
    { iso2: "CU", code: "+53", country: "Cuba" },
    { iso2: "CY", code: "+357", country: "Cyprus" },
    { iso2: "CZ", code: "+420", country: "Czechia" },

    { iso2: "DK", code: "+45", country: "Denmark" },
    { iso2: "DJ", code: "+253", country: "Djibouti" },
    { iso2: "DM", code: "+1", country: "Dominica" },
    { iso2: "DO", code: "+1", country: "Dominican Republic" },

    { iso2: "EC", code: "+593", country: "Ecuador" },
    { iso2: "EG", code: "+20", country: "Egypt" },
    { iso2: "SV", code: "+503", country: "El Salvador" },
    { iso2: "GQ", code: "+240", country: "Equatorial Guinea" },
    { iso2: "ER", code: "+291", country: "Eritrea" },
    { iso2: "EE", code: "+372", country: "Estonia" },
    { iso2: "SZ", code: "+268", country: "Eswatini" },
    { iso2: "ET", code: "+251", country: "Ethiopia" },

    { iso2: "FJ", code: "+679", country: "Fiji" },
    { iso2: "FI", code: "+358", country: "Finland" },
    { iso2: "FR", code: "+33", country: "France" },

    { iso2: "GA", code: "+241", country: "Gabon" },
    { iso2: "GM", code: "+220", country: "Gambia" },
    { iso2: "GE", code: "+995", country: "Georgia" },
    { iso2: "DE", code: "+49", country: "Germany" },
    { iso2: "GH", code: "+233", country: "Ghana" },
    { iso2: "GR", code: "+30", country: "Greece" },
    { iso2: "GD", code: "+1", country: "Grenada" },
    { iso2: "GT", code: "+502", country: "Guatemala" },
    { iso2: "GN", code: "+224", country: "Guinea" },
    { iso2: "GW", code: "+245", country: "Guinea-Bissau" },
    { iso2: "GY", code: "+592", country: "Guyana" },

    { iso2: "HT", code: "+509", country: "Haiti" },
    { iso2: "HN", code: "+504", country: "Honduras" },
    { iso2: "HK", code: "+852", country: "Hong Kong" },
    { iso2: "HU", code: "+36", country: "Hungary" },

    { iso2: "IS", code: "+354", country: "Iceland" },
    { iso2: "IN", code: "+91", country: "India" },
    { iso2: "ID", code: "+62", country: "Indonesia" },
    { iso2: "IR", code: "+98", country: "Iran" },
    { iso2: "IQ", code: "+964", country: "Iraq" },
    { iso2: "IE", code: "+353", country: "Ireland" },
    { iso2: "IL", code: "+972", country: "Israel" },
    { iso2: "IT", code: "+39", country: "Italy" },

    { iso2: "JM", code: "+1", country: "Jamaica" },
    { iso2: "JP", code: "+81", country: "Japan" },
    { iso2: "JO", code: "+962", country: "Jordan" },

    { iso2: "KZ", code: "+7", country: "Kazakhstan" },
    { iso2: "KE", code: "+254", country: "Kenya" },
    { iso2: "KI", code: "+686", country: "Kiribati" },
    { iso2: "KW", code: "+965", country: "Kuwait" },
    { iso2: "KG", code: "+996", country: "Kyrgyzstan" },

    { iso2: "LA", code: "+856", country: "Laos" },
    { iso2: "LV", code: "+371", country: "Latvia" },
    { iso2: "LB", code: "+961", country: "Lebanon" },
    { iso2: "LS", code: "+266", country: "Lesotho" },
    { iso2: "LR", code: "+231", country: "Liberia" },
    { iso2: "LY", code: "+218", country: "Libya" },
    { iso2: "LI", code: "+423", country: "Liechtenstein" },
    { iso2: "LT", code: "+370", country: "Lithuania" },
    { iso2: "LU", code: "+352", country: "Luxembourg" },

    { iso2: "MO", code: "+853", country: "Macao" },
    { iso2: "MG", code: "+261", country: "Madagascar" },
    { iso2: "MW", code: "+265", country: "Malawi" },
    { iso2: "MY", code: "+60", country: "Malaysia" },
    { iso2: "MV", code: "+960", country: "Maldives" },
    { iso2: "ML", code: "+223", country: "Mali" },
    { iso2: "MT", code: "+356", country: "Malta" },
    { iso2: "MH", code: "+692", country: "Marshall Islands" },
    { iso2: "MR", code: "+222", country: "Mauritania" },
    { iso2: "MU", code: "+230", country: "Mauritius" },
    { iso2: "MX", code: "+52", country: "Mexico" },
    { iso2: "FM", code: "+691", country: "Micronesia" },
    { iso2: "MD", code: "+373", country: "Moldova" },
    { iso2: "MC", code: "+377", country: "Monaco" },
    { iso2: "MN", code: "+976", country: "Mongolia" },
    { iso2: "ME", code: "+382", country: "Montenegro" },
    { iso2: "MA", code: "+212", country: "Morocco" },
    { iso2: "MZ", code: "+258", country: "Mozambique" },
    { iso2: "MM", code: "+95", country: "Myanmar" },

    { iso2: "NA", code: "+264", country: "Namibia" },
    { iso2: "NR", code: "+674", country: "Nauru" },
    { iso2: "NP", code: "+977", country: "Nepal" },
    { iso2: "NL", code: "+31", country: "Netherlands" },
    { iso2: "NZ", code: "+64", country: "New Zealand" },
    { iso2: "NI", code: "+505", country: "Nicaragua" },
    { iso2: "NE", code: "+227", country: "Niger" },
    { iso2: "NG", code: "+234", country: "Nigeria" },
    { iso2: "KP", code: "+850", country: "North Korea" },
    { iso2: "MK", code: "+389", country: "North Macedonia" },
    { iso2: "NO", code: "+47", country: "Norway" },

    { iso2: "OM", code: "+968", country: "Oman" },

    { iso2: "PK", code: "+92", country: "Pakistan" },
    { iso2: "PW", code: "+680", country: "Palau" },
    { iso2: "PA", code: "+507", country: "Panama" },
    { iso2: "PG", code: "+675", country: "Papua New Guinea" },
    { iso2: "PY", code: "+595", country: "Paraguay" },
    { iso2: "PE", code: "+51", country: "Peru" },
    { iso2: "PH", code: "+63", country: "Philippines" },
    { iso2: "PL", code: "+48", country: "Poland" },
    { iso2: "PT", code: "+351", country: "Portugal" },
    { iso2: "PR", code: "+1", country: "Puerto Rico" },

    { iso2: "QA", code: "+974", country: "Qatar" },

    { iso2: "RO", code: "+40", country: "Romania" },
    { iso2: "RU", code: "+7", country: "Russia" },
    { iso2: "RW", code: "+250", country: "Rwanda" },

    { iso2: "KN", code: "+1", country: "Saint Kitts and Nevis" },
    { iso2: "LC", code: "+1", country: "Saint Lucia" },
    { iso2: "VC", code: "+1", country: "Saint Vincent and the Grenadines" },
    { iso2: "WS", code: "+685", country: "Samoa" },
    { iso2: "SM", code: "+378", country: "San Marino" },
    { iso2: "ST", code: "+239", country: "São Tomé and Príncipe" },
    { iso2: "SA", code: "+966", country: "Saudi Arabia" },
    { iso2: "SN", code: "+221", country: "Senegal" },
    { iso2: "RS", code: "+381", country: "Serbia" },
    { iso2: "SC", code: "+248", country: "Seychelles" },
    { iso2: "SL", code: "+232", country: "Sierra Leone" },
    { iso2: "SG", code: "+65", country: "Singapore" },
    { iso2: "SK", code: "+421", country: "Slovakia" },
    { iso2: "SI", code: "+386", country: "Slovenia" },
    { iso2: "SB", code: "+677", country: "Solomon Islands" },
    { iso2: "SO", code: "+252", country: "Somalia" },
    { iso2: "ZA", code: "+27", country: "South Africa" },
    { iso2: "KR", code: "+82", country: "South Korea" },
    { iso2: "SS", code: "+211", country: "South Sudan" },
    { iso2: "ES", code: "+34", country: "Spain" },
    { iso2: "LK", code: "+94", country: "Sri Lanka" },
    { iso2: "SD", code: "+249", country: "Sudan" },
    { iso2: "SR", code: "+597", country: "Suriname" },
    { iso2: "SE", code: "+46", country: "Sweden" },
    { iso2: "CH", code: "+41", country: "Switzerland" },
    { iso2: "SY", code: "+963", country: "Syria" },

    { iso2: "TW", code: "+886", country: "Taiwan" },
    { iso2: "TJ", code: "+992", country: "Tajikistan" },
    { iso2: "TZ", code: "+255", country: "Tanzania" },
    { iso2: "TH", code: "+66", country: "Thailand" },
    { iso2: "TL", code: "+670", country: "Timor-Leste" },
    { iso2: "TG", code: "+228", country: "Togo" },
    { iso2: "TO", code: "+676", country: "Tonga" },
    { iso2: "TT", code: "+1", country: "Trinidad and Tobago" },
    { iso2: "TN", code: "+216", country: "Tunisia" },
    { iso2: "TR", code: "+90", country: "Turkey" },
    { iso2: "TM", code: "+993", country: "Turkmenistan" },
    { iso2: "TV", code: "+688", country: "Tuvalu" },

    { iso2: "UG", code: "+256", country: "Uganda" },
    { iso2: "UA", code: "+380", country: "Ukraine" },
    { iso2: "AE", code: "+971", country: "United Arab Emirates" },
    { iso2: "GB", code: "+44", country: "United Kingdom" },
    { iso2: "US", code: "+1", country: "United States" },
    { iso2: "UY", code: "+598", country: "Uruguay" },
    { iso2: "UZ", code: "+998", country: "Uzbekistan" },

    { iso2: "VU", code: "+678", country: "Vanuatu" },
    { iso2: "VA", code: "+39", country: "Vatican City" },
    { iso2: "VE", code: "+58", country: "Venezuela" },
    { iso2: "VN", code: "+84", country: "Vietnam" },

    { iso2: "YE", code: "+967", country: "Yemen" },

    { iso2: "ZM", code: "+260", country: "Zambia" },
    { iso2: "ZW", code: "+263", country: "Zimbabwe" },
    { iso2: "RE", code: "+262", country: "Reunion" }
].sort((a, b) => a.country.localeCompare(b.country));